/**** session clear when user enter from menue start  ****/
setTimeout(function(){        
    jQuery(".Header__MainNav .Heading, .Header__MainNav .DropdownMenu .Link .Linklist__Item").click(function() { 
      localStorage.clear();
    });

    jQuery(".Linklist__Item").click(function() {     
        localStorage.clear();
      });
}, 1600);  

